var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5B5D65;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10c5.5,0,10-4.5,10-10S17.5,2,12,2z M15.6,8.3c1.1,0,1.9,0.9,1.9,1.9 s-0.9,1.9-1.9,1.9s-1.9-0.9-1.9-1.9C13.7,9.2,14.5,8.3,15.6,8.3z M9.6,6.8c1.3,0,2.4,1.1,2.4,2.4s-1.1,2.4-2.4,2.4 c-1.3,0-2.4-1.1-2.4-2.4C7.2,7.8,8.3,6.8,9.6,6.8z M9.6,15.9v3.7c-2.4-0.8-4.3-2.6-5.1-5C5.5,13.6,8.1,13,9.6,13 c0.5,0,1.2,0.1,1.9,0.2C9.9,14.1,9.6,15.2,9.6,15.9z M12,20c-0.3,0-0.5,0-0.8,0v-4.1c0-1.4,2.9-2.1,4.4-2.1c1.1,0,2.9,0.4,3.8,1.1 C18.3,17.9,15.4,20,12,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInactive);
export default __webpack_public_path__ + "static/media/personal_inactive.25ddb71795e713c77ddbdd612188199c.svg";
export { ForwardRef as ReactComponent };